import { render, staticRenderFns } from "./AgendaHighlights.vue?vue&type=template&id=1228db92&scoped=true"
import script from "./AgendaHighlights.vue?vue&type=script&lang=js"
export * from "./AgendaHighlights.vue?vue&type=script&lang=js"
import style0 from "./AgendaHighlights.vue?vue&type=style&index=0&id=1228db92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1228db92",
  null
  
)

export default component.exports